import axios from "axios";
import { ELVIS_URL } from 'helpers/urlHelper';

axios.defaults.withCredentials = true;

const groupByConversationToArray = items => {
    const map = items.reduce((acc, item) => {
        const key = item.conversationId;
        if (!acc[key]) acc[key] = [];
        acc[key].unshift(item);
        return acc;
    }, {});
    return Object.keys(map).map(id => ({ id, messages: map[id].sort((a, b) => a.id - b.id) }));
};

const fetchHistory = async () => {
    try {
        const res = await axios(`${ELVIS_URL}/api/ai/my-history`);
        if (res?.status != 200) throw new Error(`Fetch failed: ${res.status}`);
        const data = res.data;

        return groupByConversationToArray(data);
    } catch (err) {
        console.error(err);
    }
};

const askElvis = async (newMessage) => {
    return await axios.post(`${ELVIS_URL}/api/ai/ask`, newMessage);
}

export { fetchHistory, askElvis }